import { render, staticRenderFns } from "./KeyPin.vue?vue&type=template&id=0faf40ee&scoped=true&"
import script from "./KeyPin.vue?vue&type=script&lang=js&"
export * from "./KeyPin.vue?vue&type=script&lang=js&"
import style0 from "./KeyPin.vue?vue&type=style&index=0&id=0faf40ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf40ee",
  null
  
)

export default component.exports